import { Component, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { CommonPatientModel } from 'src/app/model/common/patient';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';
import { PATIENT } from '../patient.constants';
import { PatientService } from '../patient.service';

@Component({
  selector: 'ms-common-patient-form',
  templateUrl: './patient-form.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PatientFormComponent,
      multi: true,
    },
  ],
})
export class PatientFormComponent
  extends BaseValueAccessor<CommonPatientModel>
  implements OnInit
{
  readonly screen = PATIENT;
  locations: SelectItem<KhuyanaSelectItemModel>[] = [];
  residenceHelp: SelectItem<KhuyanaSelectItemModel> = { value: {} };

  constructor(protected service: PatientService) {
    super();
  }

  ngOnInit(): void {
    if (!this.value) {
      this.value = {};
    }
    const { locations, patientData, residence } = this.service.readStore();
    patientData.subscribe((result) =>
      this.service.setPatientInformation(result)
    );
    locations.subscribe((result) => (this.locations = result));
    residence.subscribe((result) => (this.residenceHelp = result));
  }

  queryLocations = (query: string) =>
    this.service.readLocations(query).subscribe();

  verifyResidence = () => {
    const isNotValidLocation =
      this.residenceHelp == null || this.residenceHelp.value.id == null;
    if (isNotValidLocation) {
      delete this.value.residence;
    }
  };
}
